import { Icons } from "@workspace/ui/components/icons";

import { MODE } from "./mode";

export const CORE_DOC_MODES = [
  {
    id: MODE.WEB,
    name: "Web",
    icon: Icons.Website,
  },
  {
    id: MODE.MOBILE,
    name: "Mobile",
    icon: Icons.Phone,
  },
  {
    id: MODE.EXTENSION,
    name: "Browser extension",
    icon: Icons.Puzzle,
  },
] as const;

export const getDocModeIcon = (id: string) =>
  CORE_DOC_MODES.find((mode) => mode.id === id)?.icon;
